<template>
  <v-card
    class="promo-content-card mb-8 fill-height"
    :class="this.themeClass"
    flat
    :hover="true"
    :link="isLink"
    :href="linkTo"
    :target="linkTarget"
    :ripple="false"
    v-on:click.native="trackAnalytics(fields)"
  >
    <v-img>
      <sc-image class="promo-card-image" :media="fields.CardImage" />
    </v-img>
    <v-card-title>
      <v-col class="pa-0">
        <SitecoreMultiline
          :multilineField="this.fields.CardTitle"
          className="promo-content-title"
        />
      </v-col>
    </v-card-title>
    <v-card-text class="promo-content-body">
      <SitecoreMultiline :multilineField="this.fields.CardContent" />
    </v-card-text>
    <v-card-actions class="promo-actions">
      <sc-link
        class="promo-content-link"
        :field="fields.ButtonLink"
        v-if="isSitecoreExperienceEditorOn"
      />
      <a
        :href="linkTo"
        :target="linkTarget"
        class="promo-content-link"
        :field="fields.ButtonLink"
        v-else-if="isLink"
      >
        <span>{{ linkLabel }}</span>
        <v-icon class="learn_more">arrow_right_alt</v-icon>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Image, Link, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import SitecoreMultiline from '../../Sitecore/SitecoreMultiline';
export default {
  name: 'ImageCard',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    themeClass() {
      let className = 'default';
      if (
        this.fields.Theme &&
        this.fields.Theme.fields &&
        this.fields.Theme.fields.ThemeClass &&
        this.fields.Theme.fields.ThemeClass.value !== ''
      ) {
        className = this.fields.Theme.fields.ThemeClass.value;
      }
      return className;
    },
    isInternalLink() {
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.linktype === 'internal'
      ) {
        return true;
      } else {
        return false;
      }
    },
    linkLabel() {
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.text !== ''
      ) {
        return this.fields.ButtonLink.value.text;
      } else {
        return '';
      }
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    isLink() {
      if (this.isSitecoreExperienceEditorOn) {
        return false;
      }
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.href !== ''
      ) {
        return true;
      }

      return false;
    },
    // SC 9 fixed the Href vs URL - now href always come nicely:
    // external: "href": "https://xxx.com.au?testing=test&testing=test",
    // media: "href": "https://xxx.com.au/-/media/iol/data/media/img/alerticon.svg"
    // internal" "href": "/xxx"
    // anchor: "href": "#anchorxxx"
    // email: "href": "mailto:test@test.com.au?subject=xxx",
    // javascript: "href": "javascript:xxx;return false;"
    linkTo() {
      if (typeof(this.fields.ButtonLink.value.href) !='undefined') {
        return this.fields.ButtonLink.value.href;
      } else {
        return '';
      }
    },
    linkTarget() {
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.target === '_blank'
      ) {
        return '_blank';
      } else {
        return '';
      }
    },
  },
  methods: {
    trackAnalytics(fields) {
      this.$store.dispatch('analytics', {
        actionName: 'Custom-Link-Click',
        entityChange: fields.CardTitle.value,
      });
    },
  },
  components: {
    ScImage: Image,
    ScLink: Link,
    SitecoreMultiline,
  },
};
</script>
<style lang="scss" scoped>
.imagecard.promo-content-card {
  border-top: none !important;
}
.imagecard.promo-content-card.v-card--hover:hover {
  border-top: none !important;
}
.promo-content-card.v-card:before {
  opacity: 0 !important;
}
.promo-content-card {
  border-radius: 0 !important;
  min-height: 250px;
  &::v-deep {
    .v-icon {
      margin: 0px;
      &.learn_more {
        font-size: 32px;
        vertical-align: top;
      }
    }

    .promo-content-icon-left {
      align-self: flex-start;
      padding-right: 8px;
    }
    .promo-content-title {
      min-height: 52px;
      font-size: 18px;
      line-height: 130%;
      font-weight: map-get($font-weights, 'medium');
      margin-bottom: 0px;
      display: block;
      word-break: normal;
      color: map-deep-get($colors, 'blue-text', 'base');
    }
    .promo-content-body {
      font-size: 16px;
      line-height: 130%;
      font-weight: map-get($font-weights, 'light');
      margin-bottom: 110px;
      display: block;
      word-break: normal;
      color: map-deep-get($colors, 'blue-text', 'base') !important;
    }
    .promo-content-link {
      font-size: 16px;
      line-height: 32px;
      font-weight: map-get($font-weights, 'normal');
      text-transform: uppercase;
      text-decoration: none;
      span {
        line-height: 130%;
      }

      .v-icon {
        padding-left: 8px;
      }
    }
  }
  .promo-actions {
    position: absolute;
    bottom: 0;
    padding-left: 16px;
    margin-bottom: 32px;
  }
}
</style>
